// @flow
import React from 'react';
import {connect} from 'react-redux';
import gql from 'graphql-tag';
import {injectIntl, type IntlShape} from 'react-intl';
import {compose} from 'redux';
import HAPager from '@homeaway/react-pager';

import routerActions from '../../actions/router';
import {trigger as edapTrigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import resultsCountText from '../../utils/resultsCountText';
import './Pager.less';

export const fragments = {
    hitCollection: gql`
        fragment PagerHitCollection on HitCollection {
            total
            page
            pageCount
            pageSize
            from
            to
        }
    `
};
export type Shape = {|
    from: number,
    to: number,
    total: number,
    page: number,
    pageCount: number
|};
export type Props = {
    pager: Shape,
    intl: IntlShape,
    onPageChange: (number) => void
};
const defaultPager: Shape = {
    from: 0,
    total: 0,
    to: 0,
    page: 0,
    pageCount: 0
};

/**
 * Wraps the stock homeaway baseline pager with a search-friendly interface
 */
export const Pager = ({
    intl,
    onPageChange,
    pager: {from, to, total, page, pageCount}
}: Props) => {
    const pageEvent = () => {
        edapTrigger(GENERIC_EVENT, {
            eventaction: 'pagination'
        });
    };
    /* We pass in the whole router query on the page change event
    because redux-little-router currently does not handle
    persistQuery properly */
    // https://github.com/FormidableLabs/redux-little-router/issues/224
    const onNextClick = () => {
        const newPage = page + 1;
        pageEvent();
        onPageChange(newPage);
    };

    const onPrevClick = () => {
        const newPage = page - 1;
        pageEvent();
        onPageChange(newPage);
    };

    if (!total) {
        return null;
    }

    return (
        <div className="HAPager" data-wdio="HAPager">
            <HAPager
                alignCenter
                hasNext={page < pageCount}
                hasPrev={page > 1}
                pageCount={resultsCountText(from, to, total, intl)}
                onNextClick={onNextClick}
                onPrevClick={onPrevClick}
            />
        </div>
    );
};

Pager.defaultProps = {
    onPageChange: () => {},
    pager: defaultPager
};

const mapDispatchToProps = {
    onPageChange: routerActions.page
};

export default compose(
    injectIntl,
    connect(
        null,
        mapDispatchToProps
    )
)(Pager);
